<template>
<div class="row" style="height: 100%">
  <div class="d-flex flex-column">
    <div class="d-flex justify-content-center third-height">
      <div class="d-flex flex-column greetings-container">
        <h4 class="greetings">{{greeting()}}{{$t('home.comma')}} {{$t('home.dr')}}{{userName}}</h4>
        <div class="d-flex justify-content-center">
          <span class="greetings-subtitle">{{$t('home.patient_count', {count: statistics ? statistics.red + statistics.yellow + statistics.green : 0})}}</span>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center third-height">
      <DashboardCard id="red-flag-card" :number="statistics && statistics.red.toString()" :description="$t('home.red_flag')" color="#C12162"/>
      <DashboardCard id="yellow-flag-card" :number="statistics && statistics.yellow.toString()" :description="$t('home.yellow_flag')" color="#EDBB62"/>
      <DashboardCard id="green-flag-card" :number="statistics && statistics.green.toString()" :description="$t('home.green_flag')" color="#3EA046" textColor="#A5A5A5"/>
    </div>
    <div class="d-flex justify-content-center third-height">
      <div class="d-flex flex-column bottom-row">
        <router-link class="btn btn-outline-info" to="/more">{{$t('home.show_more')}}</router-link>
        <br/>
        <!--<div class="p-2">Updated just now!</div>-->
      </div>
    </div>
  </div>
</div>
</template>

<script>
import ChartCard from '@/components/Cards/ChartCard.vue'
import DashboardCard from '@/components/DashboardCard.vue'
import { mapState, mapActions } from 'vuex'
import Swatches from 'vue-swatches'
export default {
  name: 'home',
  components: {
    DashboardCard,
    ChartCard,
    Swatches
  },
  props: {
  },
  created () {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'account/profileSuccess') {
        this.userName = mutation.payload.last_name && mutation.payload.last_name.length > 0 ? mutation.payload.last_name : mutation.payload.first_name
      }
      if (mutation.type === 'test/statsSuccess') {
        this.statistics = mutation.payload
      }
    })
    if (this.$store.state.account.userUuid !== null && this.$store.state.account.userUuid.length > 0) {
      this.profile(this.$store.state.account.userUuid).then(() => {
        this.stats(this.$store.state.account.userUuid)
      })
    }
  },
  mounted () {
  },
  destroyed () {
    this.unsubscribe()
  },
  computed: {
    ...mapState('message', ['status']),
    ...mapState({
      statsItem: state => state.test.stats
    })
  },
  methods: {
    ...mapActions('account', ['profile']),
    ...mapActions('test', ['stats']),
    greeting () {
      var greeting
      var date = new Date()
      var hour = date.getHours()
      if (hour < 12) {
        greeting = this.$t('home.goodmorning')
      } else if (hour < 17) {
        greeting = this.$t('home.goodafternoon')
      } else {
        greeting = this.$t('home.goodevening')
      }
      return greeting
    }
  },
  data: () => ({
    userName: '',
    statistics: null,
    unsubscribe: null
  }),
  watch: {
  }
}
</script>

<style>
.third-height {
  height: calc(100% / 3)
}
.greetings-container {
  align-self: center;
}
.greetings {
  margin-top: 0;
  margin-bottom: 0;
  color: var(--greeting-color);
}
.greetings-subtitle {
  font-size: small;
  font-weight: normal;
}
.bottom-row {
  align-items: center;
}
#red-flag-card {
  border-top-color: var(--red-flag-color);
}
#yellow-flag-card {
  border-top-color: var(--yellow-flag-color);
}
#green-flag-card {
  border-top-color: var(--green-flag-color);
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue